/* YATS book stage — Chapter 03 "Point by point" video stage (WP-WREX-PDP2, 24 Sep 2026).
 *
 * The homepage "Why special" stage (sections/yats-why.liquid) ported to a module-free asset.
 * Everything the stage shows is BUILT HERE from the product's yats.book_stage JSON (printed
 * once by snippets/yats-persona-deal.liquid as <script type="application/json"
 * data-yats-book-data>), so the theme snippet is only a container + a <noscript> fallback,
 * and the preview harness can mount the very same code on a copy of the live page.
 *
 * Differences from yats-why:
 *  (a) holds, seek times, loop tail and sources come from the JSON, not constants;
 *  (b) the film is the DEALT child's (html[data-yats-persona] / the yats:persona event), and
 *      its src is set only when the stage nears the viewport (rootMargin 200px); phones
 *      (<= 749px) load the light encode;
 *  (c) seamless loop: the auto-cycle wraps from the last point to the first by playing the
 *      loop tail (the book closes back onto its cover) and seeking to loop_tail.restart;
 *  (d) callout boxes auto-flip left/right, then up/down, when they would leave the stage;
 *  (e) reduced motion: the video is never created; each point shows its keyframe still;
 *  (f) setup mode (?stage_coords=1 or the theme editor): no auto-cycle, the selected
 *      point's callouts show at once, and a crosshair reads x/y % of the stage;
 *  (g) unchanged: the touch-driven phone carousel, transitionTo (forward 1x, reverse scrub,
 *      in-between hold skip, iOS resume-after-seek), draw-on-settle / fly-away callouts,
 *      hover pause and visibilitychange;
 *  (h) a child's own dot: persona.callout_xy {"<point>.<callout id>": [x, y]} moves that
 *      callout for that child only (their feature sits elsewhere in their film).
 */
(function () {
  'use strict';
  if (window.YatsBookStage) return;

  var D = document;
  var KEY_RE = /^[a-z0-9_-]{1,32}$/;

  function readData() {
    try {
      var e = D.querySelector('script[data-yats-book-data]');
      return e ? JSON.parse(e.textContent || 'null') : null;
    } catch (err) { return null; }
  }
  function mk(tag, cls, attrs) {
    var e = D.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) { if (attrs[k] != null) e.setAttribute(k, attrs[k]); }
    return e;
  }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clampPct(v) { var n = num(v, 50); return Math.max(0, Math.min(100, n)); }
  function mq(q) { try { return !!(window.matchMedia && window.matchMedia(q).matches); } catch (e) { return false; } }

  function personaFor(data, key) {
    var list = Array.isArray(data.personas) ? data.personas : [];
    var i;
    for (i = 0; i < list.length; i++) if (list[i] && list[i].key === key) return list[i];
    for (i = 0; i < list.length; i++) if (list[i] && list[i].key === data['default']) return list[i];
    return list[0] || null;
  }

  function mount(root, data) {
    if (!root || root.__yatsBs) return null;
    var st = data && data.stage;
    if (!st || st.enabled === false || !Array.isArray(st.points) || !st.points.length) return null;
    root.__yatsBs = true;
    root.setAttribute('data-bs-ready', '1');

    var reduce = mq('(prefers-reduced-motion: reduce)');
    var isTouch = mq('(max-width: 749px)');
    var pickMode = !!((window.Shopify && window.Shopify.designMode) || /[?&]stage_coords=1/.test(location.search));
    var points = st.points.filter(function (p) { return p && typeof p.title === 'string'; });
    var N = points.length;
    var HOLDS = (Array.isArray(st.holds) ? st.holds : []).filter(function (h) { return Array.isArray(h) && h.length === 2 && isFinite(+h[0]) && isFinite(+h[1]); }).map(function (h) { return [+h[0], +h[1]]; });
    var tail = st.loop_tail && isFinite(+st.loop_tail.from) && isFinite(+st.loop_tail.to) ? { from: +st.loop_tail.from, to: +st.loop_tail.to, restart: num(st.loop_tail.restart, num(points[0].t, 0)) } : null;
    var hintText = root.getAttribute('data-hint') || '';
    var label = root.getAttribute('data-label') || 'Every point of personalisation';
    var uid = 'bs' + Math.random().toString(36).slice(2, 8);
    var api = { video: null };

    var key = D.documentElement.getAttribute('data-yats-persona');
    if (!key || !KEY_RE.test(key)) key = data['default'];
    var persona = personaFor(data, key);

    // ---------- build the markup ----------
    var grid = mk('div', 'bs-grid');
    var stage = mk('div', 'bs-stage', { 'data-bs-stage': '', id: uid + '-stage', role: 'tabpanel', 'aria-label': label });
    var still = mk('img', 'bs-still', { alt: '', decoding: 'async', 'aria-hidden': 'true' });
    stage.appendChild(still);
    var vid = null;
    if (!reduce) {
      vid = mk('video', 'bs-video', { muted: '', playsinline: '', 'webkit-playsinline': '', preload: 'none', disablepictureinpicture: '', disableremoteplayback: '', 'aria-hidden': 'true', tabindex: '-1' });
      vid.muted = true; vid.playsInline = true;
      stage.appendChild(vid);
    }
    var layer = mk('div', 'bs-callouts');
    var groups = [];
    points.forEach(function (p, i) {
      var g = mk('div', 'bs-cgroup', { 'data-cgroup': String(i) });
      g.hidden = true;
      (Array.isArray(p.callouts) ? p.callouts : []).slice(0, 3).forEach(function (c) {
        if (!c || typeof c.text !== 'string' || !c.text) return;
        var side = /^(ur|ul|dr|dl)$/.test(c.side) ? c.side : 'ur';
        var co = mk('div', 'bs-callout side-' + side, { 'data-side': side });
        co.style.left = clampPct(c.x) + '%';
        co.style.top = clampPct(c.y) + '%';
        co.appendChild(mk('span', 'bs-callout-dot'));
        co.appendChild(mk('span', 'bs-callout-line'));
        var box = mk('span', 'bs-callout-box');
        box.textContent = c.text;
        box.__c = c;
        co.__c = c;
        co.__k = (i + 1) + '.' + (typeof c.id === 'string' ? c.id : '');
        co.appendChild(box);
        g.appendChild(co);
      });
      layer.appendChild(g);
      groups.push(g);
    });
    stage.appendChild(layer);
    var hint = null;
    if (hintText) { hint = mk('span', 'bs-hint'); hint.textContent = hintText; stage.appendChild(hint); }

    var list = mk('div', 'bs-points', { role: 'tablist', 'aria-label': label });
    var pills = points.map(function (p, i) {
      var b = mk('button', 'bs-point', { type: 'button', role: 'tab', id: uid + '-p' + i, 'aria-controls': uid + '-stage', 'aria-selected': i === 0 ? 'true' : 'false', tabindex: i === 0 ? '0' : '-1', 'data-bs-point': String(i) });
      var n = mk('span', 'bs-point-num', { 'aria-hidden': 'true' }); n.textContent = String(i + 1);
      var body = mk('span', 'bs-point-body');
      var h = mk('span', 'bs-point-title'); h.textContent = p.title;
      body.appendChild(h);
      if (typeof p.body === 'string' && p.body) { var t = mk('span', 'bs-point-text'); t.textContent = p.body; body.appendChild(t); }
      b.appendChild(n); b.appendChild(body);
      list.appendChild(b);
      return b;
    });
    grid.appendChild(stage);
    grid.appendChild(list);
    root.appendChild(grid);

    // ---------- persona-dependent media ----------
    function stillFor(i) {
      var s = persona && Array.isArray(persona.stills) ? persona.stills : [];
      return s[i] || s[0] || '';
    }
    function filmFor() {
      var f = (persona && persona.film) || {};
      // Read the width when the film is chosen (not at mount): a tab laid out while hidden can
      // report a phone width at mount and would pin the light encode on a desktop.
      return (mq('(max-width: 749px)') && f.mobile) ? f.mobile : (f.desktop || f.mobile || '');
    }
    function kitText(c) {
      var k = persona && persona.kit;
      return (c.by_kit && k && typeof c.by_kit[k] === 'string' && c.by_kit[k]) ? c.by_kit[k] : c.text;
    }
    // A child whose feature sits elsewhere in their own film (e.g. the shirt crest on a
    // different hero) carries its projected dot in persona.callout_xy {"<point>.<id>": [x, y]};
    // every other dot is the shared projection in the point's callouts.
    function xyFor(co) {
      var m = persona && persona.callout_xy, v = (m && typeof m === 'object' && co.__k) ? m[co.__k] : null;
      return (Array.isArray(v) && v.length === 2 && isFinite(+v[0]) && isFinite(+v[1])) ? v : null;
    }
    function applyPersonaCopy() {
      groups.forEach(function (g) {
        [].forEach.call(g.querySelectorAll('.bs-callout'), function (co) {
          var c = co.__c; if (!c) return;
          var b = co.querySelector('.bs-callout-box'); if (b) b.textContent = kitText(c);
          var xy = xyFor(co);
          co.style.left = clampPct(xy ? xy[0] : c.x) + '%';
          co.style.top = clampPct(xy ? xy[1] : c.y) + '%';
        });
      });
    }
    function setStill(i) { var u = stillFor(i); if (u && still.getAttribute('src') !== u) still.setAttribute('src', u); }
    applyPersonaCopy();
    setStill(0);
    if (vid && stillFor(0)) vid.setAttribute('poster', stillFor(0));

    // ---------- hold helpers + transitionTo (ported verbatim in behaviour) ----------
    function holdOf(tt) { for (var i = 0; i < HOLDS.length; i++) { if (tt >= HOLDS[i][0] - 0.03 && tt <= HOLDS[i][1] + 0.03) return i; } return -1; }
    var _raf = null, _tu = null, _end = null, _seq = 0;
    function _clearTrans() {
      if (_raf) { cancelAnimationFrame(_raf); _raf = null; }
      if (_tu && vid) { vid.removeEventListener('timeupdate', _tu); _tu = null; }
      if (_end && vid) { vid.removeEventListener('ended', _end); _end = null; }
    }
    function transitionTo(t, instant, onDone0) {
      if (!vid) { if (onDone0) onDone0(); return; }
      _clearTrans();
      // Only the latest request may finish: calls queued before the metadata arrived (or a pick
      // made mid-transition) are superseded instead of racing each other to onDone.
      var my = ++_seq;
      var onDone = function () { if (my === _seq && onDone0) onDone0(); };
      var run = function () {
        if (my !== _seq || !vid) return;
        _clearTrans();
        var c = vid.currentTime;
        if (instant || reduce || Math.abs(t - c) < 0.06) { vid.pause(); try { vid.currentTime = t; } catch (e) {} if (onDone) onDone(); return; }
        var th = holdOf(t);
        if (t > c) {
          vid.playbackRate = 1;
          var arrive = function () { _clearTrans(); vid.pause(); try { vid.currentTime = Math.min(t, (vid.duration || t)); } catch (e) {} if (onDone) onDone(); };
          _tu = function () {
            var cc = vid.currentTime, hi = holdOf(cc);
            if (cc >= t - 0.02) { arrive(); return; }                                    // arrived: settle
            if (hi > -1 && hi !== th && cc < HOLDS[hi][1] - 0.05) { vid.currentTime = HOLDS[hi][1]; } // skip an in-between hold
            if (vid.paused) { var pp = vid.play(); if (pp && pp.catch) pp.catch(function () {}); }    // iOS: a seek can pause playback
          };
          _end = arrive;                                                                  // a target at the very end fires 'ended' first
          vid.addEventListener('timeupdate', _tu);
          vid.addEventListener('ended', _end);
          var p = vid.play(); if (p && p.catch) p.catch(function () { try { vid.currentTime = t; } catch (e) {} if (onDone) onDone(); });
        } else {
          vid.pause();
          var skip = 0; for (var hj = 0; hj < HOLDS.length; hj++) { if (hj !== th && HOLDS[hj][0] > t && HOLDS[hj][1] < c) skip += (HOLDS[hj][1] - HOLDS[hj][0]); }
          var from = c, dist = c - t, dur = Math.max(0.15, dist - skip), t0 = null;
          var step = function (ts) {
            if (!t0) t0 = ts;
            var k = dur > 0 ? Math.min(1, (ts - t0) / (dur * 1000)) : 1, ct = from - dist * k;
            var hi = holdOf(ct); if (hi > -1 && hi !== th && ct > HOLDS[hi][0] + 0.05) { ct = HOLDS[hi][0]; }
            vid.currentTime = ct;
            if (k < 1) { _raf = requestAnimationFrame(step); } else { _raf = null; vid.currentTime = t; if (onDone) onDone(); }
          };
          _raf = requestAnimationFrame(step);
        }
      };
      if (vid.readyState >= 1) run(); else vid.addEventListener('loadedmetadata', run, { once: true });
    }

    // ---------- state ----------
    var DWELL = 2400, IDLE = 7000;
    var autoEnabled = !reduce && !pickMode, cur = 0, autoPaused = false, inView = false;
    var dwellTimer = null, resumeTimer = null;
    // True from a pick until its film settles: the idle resume must never hijack a long transition
    // (a manual jump across the book can outlast IDLE), it waits for the settle instead.
    var moving = false;
    var autoScrolling = false, _autoScrollClr = null;
    function armAutoScroll() { autoScrolling = true; if (_autoScrollClr) clearTimeout(_autoScrollClr); _autoScrollClr = setTimeout(function () { autoScrolling = false; }, 600); }

    function setActive(idx) {
      cur = idx;
      pills.forEach(function (p, i) { var on = i === idx; p.setAttribute('aria-selected', on ? 'true' : 'false'); p.tabIndex = on ? 0 : -1; });
      stage.setAttribute('aria-labelledby', uid + '-p' + idx);
      if (hint) hint.style.opacity = '0';
    }

    // A wrapped, balanced box keeps its full max-width (text-wrap: balance never narrows the box),
    // which leaves a gap beside the shorter lines on phones. Size a multi-line box to its widest
    // line instead; one-line boxes already hug their text (width: max-content).
    function hugBox(box) {
      box.style.width = '';
      if (!D.createRange) return;
      var r = D.createRange(); r.selectNodeContents(box);
      var rects = r.getClientRects(); if (!rects || rects.length < 2) return;
      var l = Infinity, rt = -Infinity;
      for (var i = 0; i < rects.length; i++) { if (rects[i].width > 0) { l = Math.min(l, rects[i].left); rt = Math.max(rt, rects[i].right); } }
      var ow = box.offsetWidth, bw = box.getBoundingClientRect().width, k = (bw > 0 && ow > 0) ? ow / bw : 1;   // undo any draw-on scale
      var cs = window.getComputedStyle(box), extra = 0;
      if (cs.boxSizing === 'border-box') extra = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
      var w = Math.ceil((rt - l) * k + extra + 1);
      if (isFinite(w) && w > 0 && w < ow) box.style.width = w + 'px';
    }

    // Box auto-flip (d): measured from layout (offsetWidth/Height ignore the draw-on scale).
    var PAD = 8;
    function fitGroup(g) {
      var sw = stage.clientWidth, sh = stage.clientHeight;
      if (!sw || !sh) return;
      [].forEach.call(g.querySelectorAll('.bs-callout'), function (co) {
        var box = co.querySelector('.bs-callout-box'); if (!box) return;
        hugBox(box);
        var want = co.getAttribute('data-side') || 'ur';
        var ax = parseFloat(co.style.left) / 100 * sw, ay = parseFloat(co.style.top) / 100 * sh;
        var bw = box.offsetWidth, bh = box.offsetHeight, off = 32;
        function over(side) {
          var x0 = side.charAt(1) === 'r' ? ax + off : ax - off - bw, y0 = side.charAt(0) === 'u' ? ay - off - bh : ay + off;
          return Math.max(0, PAD - x0) + Math.max(0, x0 + bw - (sw - PAD)) + Math.max(0, PAD - y0) + Math.max(0, y0 + bh - (sh - PAD));
        }
        var flipH = function (s) { return s.charAt(0) + (s.charAt(1) === 'r' ? 'l' : 'r'); };
        var flipV = function (s) { return (s.charAt(0) === 'u' ? 'd' : 'u') + s.charAt(1); };
        var best = want, bo = over(want);
        [flipH(want), flipV(want), flipV(flipH(want))].forEach(function (s) { var o = over(s); if (o < bo - 0.5) { bo = o; best = s; } });
        co.className = 'bs-callout side-' + best;
        // No side fits (a narrow phone stage): nudge the box back inside; the leader still
        // meets its corner region, and the dot never moves off its feature.
        var dx = 0, dy = 0;
        if (bo > 0.5) {
          var x0 = best.charAt(1) === 'r' ? ax + off : ax - off - bw, y0 = best.charAt(0) === 'u' ? ay - off - bh : ay + off;
          if (x0 < PAD) dx = PAD - x0; else if (x0 + bw > sw - PAD) dx = (sw - PAD) - (x0 + bw);
          if (y0 < PAD) dy = PAD - y0; else if (y0 + bh > sh - PAD) dy = (sh - PAD) - (y0 + bh);
        }
        box.style.transform = (dx || dy) ? 'translate(' + Math.round(dx) + 'px,' + Math.round(dy) + 'px)' : '';
      });
    }

    var _shownGroup = -1, _leaveTO = null;
    function showCallouts(idx) {
      if (_leaveTO) { clearTimeout(_leaveTO); _leaveTO = null; }
      groups.forEach(function (g, i) {
        if (i === idx) { g.hidden = false; g.classList.remove('is-leaving'); fitGroup(g); void g.offsetWidth; g.classList.add('is-shown'); }
        else { g.classList.remove('is-shown', 'is-leaving'); g.hidden = true; }
      });
      _shownGroup = idx;
    }
    function hideCallouts() {
      if (_shownGroup < 0) return;
      var g = groups[_shownGroup]; _shownGroup = -1;
      if (!g) return;
      g.classList.remove('is-shown'); g.classList.add('is-leaving');
      if (_leaveTO) clearTimeout(_leaveTO);
      _leaveTO = setTimeout(function () { g.classList.remove('is-leaving'); g.hidden = true; }, 340);
    }
    function clearDwell() { if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; } }
    function scheduleAuto(ms) {
      clearDwell();
      if (!autoEnabled || autoPaused || !inView) return;
      dwellTimer = setTimeout(function () {
        if (!autoEnabled || autoPaused || !inView || D.hidden) return;
        var n = (cur + 1) % N;
        goTo(n, true, false);
        if (isTouch && list) { armAutoScroll(); scrollToCard(n, false); }
      }, ms == null ? DWELL : ms);
    }
    function pauseAuto(withResume) {
      autoPaused = true; clearDwell();
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      if (withResume) { resumeTimer = setTimeout(function () { autoPaused = false; if (!moving) scheduleAuto(400); }, IDLE); }
    }
    function resumeAuto() { if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; } autoPaused = false; scheduleAuto(); }

    function scrollToCard(i, instant) {
      var p = pills[i]; if (!p) return;
      var target = Math.max(0, p.offsetLeft - (list.clientWidth - p.offsetWidth) / 2);
      if (instant) { list.scrollLeft = target; return; }
      var from = list.scrollLeft, dist = target - from, t0 = null;
      if (Math.abs(dist) < 1) return;
      list.style.scrollSnapType = 'none';
      requestAnimationFrame(function anim(ts) {
        if (t0 === null) t0 = ts; var k = Math.min(1, (ts - t0) / 380);
        var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        list.scrollLeft = from + dist * e;
        if (k < 1) { requestAnimationFrame(anim); } else { list.style.scrollSnapType = ''; }
      });
    }

    // Loop tail (c): the book closes back onto its cover, then the film restarts on point 1.
    function viaTail(onDone) {
      transitionTo(tail.to, false, function () {
        try { vid.currentTime = tail.restart; } catch (e) {}
        if (onDone) onDone();
      });
    }

    // Seconds of reverse scrub from c back to t (in-between holds are skipped, as transitionTo does).
    function reverseCost(c, t) {
      var th = holdOf(t), skip = 0;
      for (var hj = 0; hj < HOLDS.length; hj++) { if (hj !== th && HOLDS[hj][0] > t && HOLDS[hj][1] < c) skip += (HOLDS[hj][1] - HOLDS[hj][0]); }
      return Math.max(0, c - t - skip);
    }
    function goTo(idx, auto, focus) {
      var btn = pills[idx]; if (!btn) return;
      var from = cur;
      clearDwell();
      if (!pickMode) hideCallouts();
      setActive(idx); if (focus) btn.focus();
      var t = num(points[idx].t, NaN);
      var done = function () { moving = false; if (!pickMode) showCallouts(idx); scheduleAuto(); };
      moving = true;
      if (reduce || !vid) { setStill(idx); done(); }
      else if (!isFinite(t)) { done(); }
      else {
        var c = vid.currentTime || 0;
        // Back to point 1: the auto-cycle wrap ALWAYS closes the book through the loop tail
        // (forward only); a manual pick takes the tail only when it is shorter than scrubbing back.
        var tailBetter = idx === 0 && tail && c > t + 0.06 && (auto ? from === N - 1 : (tail.to - c) < reverseCost(c, t));
        if (tailBetter) viaTail(done); else transitionTo(t, false, done);
      }
      if (pickMode) { setStill(idx); showCallouts(idx); }
    }

    pills.forEach(function (p, i) {
      p.addEventListener('click', function () { pauseAuto(true); if (isTouch) { armAutoScroll(); scrollToCard(i, false); } goTo(i, false, false); });
      p.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % N;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + N) % N;
        else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = N - 1;
        if (n !== null) { e.preventDefault(); pauseAuto(true); if (isTouch) { armAutoScroll(); scrollToCard(n, false); } goTo(n, false, true); }
      });
    });
    setActive(0);
    if (reduce || pickMode) { setStill(0); showCallouts(0); }

    if (mq('(hover: hover)')) {
      root.addEventListener('mouseenter', function () { pauseAuto(false); });
      root.addEventListener('mouseleave', function () { resumeAuto(); });
    }
    D.addEventListener('visibilitychange', function () { if (D.hidden) clearDwell(); else scheduleAuto(); });
    window.addEventListener('resize', function () { if (_shownGroup > -1 && groups[_shownGroup]) fitGroup(groups[_shownGroup]); });

    // Phone: the centred carousel card drives the film; TOUCH events (they fire on real devices
    // where scroll events and IntersectionObserver may not), then a short settle poll.
    if (isTouch) {
      var geomCenteredIdx = function () {
        var sr = list.getBoundingClientRect(), mid = sr.left + sr.width / 2, best = cur, bd = Infinity;
        pills.forEach(function (p, i) { var pr = p.getBoundingClientRect(), cc = pr.left + pr.width / 2, d = Math.abs(cc - mid); if (d < bd) { bd = d; best = i; } });
        return best;
      };
      var driveNow = function () { if (autoScrolling) return; var k = geomCenteredIdx(); if (k !== cur) { pauseAuto(true); goTo(k, false, false); } };
      var _mv = 0;
      var onMove = function () { if (_mv) return; _mv = requestAnimationFrame(function () { _mv = 0; driveNow(); }); };
      var _poll = null, _pn = 0;
      var settleDrive = function () { if (_poll) clearTimeout(_poll); _pn = 0; (function t() { driveNow(); if (++_pn < 16) { _poll = setTimeout(t, 60); } })(); };
      list.addEventListener('touchstart', function () { autoScrolling = false; pauseAuto(true); }, { passive: true });
      list.addEventListener('touchmove', onMove, { passive: true });
      list.addEventListener('touchend', settleDrive, { passive: true });
      var _st = null;
      list.addEventListener('scroll', function () { if (autoScrolling) return; if (_st) clearTimeout(_st); _st = setTimeout(driveNow, 80); }, { passive: true });
    }

    // Load the dealt child's film as the stage nears view; auto-cycle only while it is in view.
    // A film that fails to load (404, codec, network) must not stall the stage: drop the video
    // and carry on with the keyframe stills, exactly like reduced motion.
    function dropVideo() {
      if (!vid) return;
      _seq++; _clearTrans(); moving = false;
      try { vid.removeAttribute('src'); vid.load(); } catch (e) {}
      if (vid.parentNode) vid.parentNode.removeChild(vid);
      vid = null; api.video = null;
      setStill(cur); showCallouts(cur); scheduleAuto();
    }
    if (vid) vid.addEventListener('error', dropVideo);
    var _loaded = false;
    function loadVid() {
      if (_loaded || !vid) return;
      var src = filmFor();
      if (!src) { dropVideo(); return; }
      _loaded = true;
      try { vid.src = src; } catch (e) {}
      try { vid.load(); } catch (e) {}
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) loadVid(); }); }, { rootMargin: '200px 0px' }).observe(root);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          inView = e.isIntersecting;
          if (e.isIntersecting) {
            loadVid();
            if (autoEnabled && !dwellTimer && !autoPaused) { if (_shownGroup < 0) goTo(cur, true, false); else scheduleAuto(); }
          }
          else clearDwell();
        });
      }, { threshold: 0.2 }).observe(root);
    } else { inView = true; loadVid(); if (autoEnabled) goTo(0, true, false); }

    // A persona dealt AFTER mount (script order) swaps the film in place, keeping the time.
    function onPersona(ev) {
      var k = ev && ev.detail && ev.detail.key;
      if (!k || !KEY_RE.test(k) || (persona && persona.key === k)) return;
      persona = personaFor(data, k);
      applyPersonaCopy();
      if (_shownGroup > -1 && groups[_shownGroup]) fitGroup(groups[_shownGroup]);
      setStill(cur);
      if (vid) {
        if (stillFor(0)) vid.setAttribute('poster', stillFor(0));
        if (_loaded) { var tt = vid.currentTime; _loaded = false; loadVid(); vid.addEventListener('loadedmetadata', function () { try { vid.currentTime = tt; } catch (e) {} }, { once: true }); }
      }
    }
    D.addEventListener('yats:persona', onPersona);

    // Setup mode (f): crosshair coordinate reader — hover to read, click to copy "x, y".
    if (pickMode) {
      stage.style.cursor = 'crosshair';
      var cross = mk('div', 'bs-pick-cross'), read = mk('div', 'bs-pick-read');
      read.textContent = 'hover to read · click to copy';
      stage.appendChild(cross); stage.appendChild(read);
      var coords = function (e) { var r = stage.getBoundingClientRect(); return [Math.round((e.clientX - r.left) / r.width * 1000) / 10, Math.round((e.clientY - r.top) / r.height * 1000) / 10]; };
      stage.addEventListener('mousemove', function (e) {
        var c = coords(e); cross.style.left = c[0] + '%'; cross.style.top = c[1] + '%'; cross.style.display = 'block';
        read.textContent = 'x ' + c[0] + '   y ' + c[1] + '      (point ' + (cur + 1) + ')';
      });
      stage.addEventListener('mouseleave', function () { cross.style.display = 'none'; });
      stage.addEventListener('click', function (e) {
        var c = coords(e), t = c[0] + ', ' + c[1];
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).catch(function () {});
        read.textContent = 'copied  x ' + c[0] + '  y ' + c[1];
      });
    }

    api = {
      root: root, video: vid, points: points, persona: function () { return persona && persona.key; },
      go: function (i) { pauseAuto(true); goTo(i, false, false); }, current: function () { return cur; },
      pause: function () { pauseAuto(false); }, resume: resumeAuto
    };
    root.__yatsBsApi = api;
    return api;
  }

  function init() {
    var roots = D.querySelectorAll('[data-yats-bstage-root]');
    if (!roots.length) return;
    var data = readData();
    if (!data) return;
    for (var i = 0; i < roots.length; i++) mount(roots[i], data);
  }

  window.YatsBookStage = { mount: mount, init: init, version: 1 };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
